import { List } from 'immutable';
import PermissionConstants from 'shared/constants/Permissions';

export const hasGlobalElementsFullAccess = (permissions = List()) => {
  const hasPermission = permissions.find((perm) => {
    return perm.get('name') === PermissionConstants.globalElementsFullAccess;
  });

  return !!hasPermission;
};

export const hasTeleprompterFullAccess = (permissions = List()) => {
  const permission = permissions.find((perm) => {
    return perm.get('name') === PermissionConstants.teleprompterFullAccess;
  });

  if (!permission) return false;

  if (permission.has('status') && permission.get('status') !== 'enabled') {
    return false;
  }
  return true;
};

export default {
  hasGlobalElementsFullAccess,
};
